<!-- eslint-disable-next-line @angular-eslint/template/no-inline-styles -->
<i
	[class]="iconClass"
	[class.fa-fw]="fixedWidth"
	[class.align-middle]="fixedWidth"
	[class.fa-border]="bordered"
	[class.disabled-container]="disabled"
	[style]="style"
></i>
